import { API_URL } from "../config";

const R2_PATH_MARKERS = ["archivos-curso/", "imagenes-curso/"];

/**
 * @param {string} nom
 * @returns {boolean}
 */
function nombreLooksLikeStorageKey(nom) {
  if (!nom) {
    return false;
  }
  const lower = nom.toLowerCase();
  return R2_PATH_MARKERS.some((m) => lower.startsWith(m));
}

/**
 * Extract R2-style key from an http(s) URL pathname (markers + decodeURIComponent fallback).
 * @param {string} value
 * @returns {string}
 */
function extractKeyFromHttpUrl(value) {
  const v = typeof value === "string" ? value.trim() : "";
  if (!v || !/^https?:\/\//i.test(v)) {
    return "";
  }
  try {
    const pathname = new URL(v).pathname.replace(/^\/+/, "");
    for (let i = 0; i < R2_PATH_MARKERS.length; i += 1) {
      const m = R2_PATH_MARKERS[i];
      const idx = pathname.indexOf(m);
      if (idx >= 0) {
        const encodedSegment = pathname.slice(idx);
        try {
          return decodeURIComponent(encodedSegment);
        } catch {
          return encodedSegment;
        }
      }
    }
  } catch {
    return "";
  }
  return "";
}

/**
 * Resolves the R2 object key for course material (never a bare public URL as the primary source).
 * @param {{ storageKey?: string, nombre?: string, url?: string } | null | undefined} archivo
 * @returns {string}
 */
export function getCourseFileObjectKey(archivo) {
  if (!archivo || typeof archivo !== "object") {
    return "";
  }
  const sk = typeof archivo.storageKey === "string" ? archivo.storageKey.trim() : "";
  if (sk.length > 0 && !/^https?:\/\//i.test(sk)) {
    return sk;
  }

  const fromUrl = extractKeyFromHttpUrl(typeof archivo.url === "string" ? archivo.url : "");
  if (fromUrl) {
    return fromUrl;
  }

  const nom = typeof archivo.nombre === "string" ? archivo.nombre.trim() : "";
  if (nom.length === 0) {
    return "";
  }
  if (/^https?:\/\//i.test(nom)) {
    return extractKeyFromHttpUrl(nom);
  }
  if (nombreLooksLikeStorageKey(nom)) {
    return nom;
  }
  return "";
}

/**
 * Same-origin API URL that streams the file after cookie/session auth (no presigned URL).
 * @param {string} objectKey
 * @returns {string}
 */
export function getCourseFileViewUrl(objectKey) {
  if (typeof objectKey !== "string" || objectKey.trim() === "") {
    throw new Error("getCourseFileViewUrl: objectKey is required");
  }
  const key = objectKey.trim();
  const params = new URLSearchParams({ key });
  return `${API_URL}/api/files/view?${params.toString()}`;
}
